import { type FC } from 'react';

import InfoIcon from '@/assets/svg/ui-elements/info-circle-alt.svg';

import { theme } from '../../theme';
import Tooltip from '../Tooltip';
import Typography from '../Typography';
import { StyledLabel, StyledLeft, StyledTooltipTrigger } from './Label.styled';
import type { LabelProps } from './types';

const Label: FC<LabelProps> = ({
  children,
  id,
  htmlFor,
  optional,
  required,
  topRightLabel,
  tooltip,
  className,
  disabled,
}) => (
  <StyledLabel id={id} htmlFor={htmlFor} className={className} data-disabled={disabled}>
    <StyledLeft>
      <Typography as="span" variant="body3" color={theme.colors.text.primary} noWrap>
        {children}
      </Typography>
      {optional && (
        <Typography as="span" variant="body3" color={theme.colors.text.secondary} noWrap>
          (optional)
        </Typography>
      )}
      {required && (
        <Typography as="span" variant="body3" color={theme.colors.text.error}>
          *
        </Typography>
      )}
      {tooltip && (
        <Tooltip title={tooltip} side="top">
          <StyledTooltipTrigger>
            <InfoIcon />
          </StyledTooltipTrigger>
        </Tooltip>
      )}
    </StyledLeft>
    {topRightLabel && (
      <Typography as="span" variant="body4" color={theme.colors.white[80]} noWrap>
        {topRightLabel}
      </Typography>
    )}
  </StyledLabel>
);

Label.displayName = 'Label';

export default Label;
